import type { SchedulesResponse } from "src/api/SchedulesResponse";

// level 3 events denote Search & Schedule Searches
// level 4 events denote Ticket Selection & Live Schedule Exits
export const SEARCH_SCHEDULE_REQUEST = 3;
export const TICKET_SELECTION_LIVE_SCHEDULE_EXIT = 4;

export const getCarriers = (
  schedulesResponse?: SchedulesResponse,
): string[] | undefined => {
  if (!schedulesResponse?.carriers) return;

  return schedulesResponse.carriers.map((c) => c.name);
};
